import { ServiceResponse } from "../ServiceResponse";
import { LoginUser } from "../../LoginUser";

export class LoginResponse extends ServiceResponse
{
  public ValidUser: LoginUser | null = null;
}
